import type { TContextualTab, TNavigationItem } from '~/src/types/navigation'

const LITHIUM_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/lithium',
  },
  {
    name: 'Market Insights',
    href: '/lithium/market-insights/analysis',
  },
  {
    name: 'Lithium Prices',
    href: '/lithium/prices',
  },
  {
    name: 'Data & Reports',
    href: '/lithium/data-reports/price-assessments',
  },
  {
    name: 'Sustainability',
    href: '/lithium/sustainability/sustainability-index',
  },
]

const COBALT_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/cobalt',
  },
  {
    name: 'Market Insights',
    href: '/cobalt/market-insights/analysis',
  },
  {
    name: 'Cobalt Prices',
    href: '/cobalt/prices',
  },
  {
    name: 'Data & Reports',
    href: '/cobalt/data-reports/price-assessments',
  },
  {
    name: 'Sustainability',
    href: '/cobalt/sustainability/sustainability-index',
  },
]

const NICKEL_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/nickel',
  },
  {
    name: 'Market Insights',
    href: '/nickel/market-insights/analysis',
  },
  {
    name: 'Nickel Prices',
    href: '/nickel/prices',
  },
  {
    name: 'Data & Reports',
    href: '/nickel/data-reports/price-assessments',
  },
  {
    name: 'Sustainability',
    href: '/nickel/sustainability/sustainability-index',
  },
]

const COPPER_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/copper/portal',
  },
  {
    name: 'Market Insights',
    href: '/copper/market-insights/analysis',
  },
  {
    name: 'Data & Reports',
    href: '/copper/data-reports/forecasts',
  },
]

const SYNTHETIC_GRAPHITE_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/synthetic-graphite',
  },
  {
    name: 'Market Insights',
    href: '/synthetic-graphite/market-insights/analysis',
  },
  {
    name: 'Synthetic Graphite Prices',
    href: '/synthetic-graphite/prices',
  },
  {
    name: 'Data & Reports',
    href: '/synthetic-graphite/data-reports/price-assessments',
  },
  {
    name: 'Sustainability',
    href: '/synthetic-graphite/sustainability/sustainability-index',
  },
]

const NATURAL_GRAPHITE_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/natural-graphite',
  },
  {
    name: 'Market Insights',
    href: '/natural-graphite/market-insights/analysis',
  },
  {
    name: 'Natural Graphite Prices',
    href: '/natural-graphite/prices',
  },
  {
    name: 'Data & Reports',
    href: '/natural-graphite/data-reports/price-assessments',
  },
  {
    name: 'Sustainability',
    href: '/natural-graphite/sustainability/sustainability-index',
  },
]

const RARE_EARTHS_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/rare-earths',
  },
  {
    name: 'Market Insights',
    href: '/rare-earths/market-insights/analysis',
  },
  {
    name: 'Rare Earths Prices',
    href: '/rare-earths/prices',
  },
  {
    name: 'Data & Reports',
    href: '/rare-earths/data-reports/price-assessments',
  },
  {
    name: 'Sustainability',
    href: '/rare-earths/sustainability/sustainability-index',
  },
]

const MANGANESE_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/manganese',
  },
  {
    name: 'Market Insights',
    href: '/manganese/market-insights/analysis',
  },
  {
    name: 'Data & Reports',
    href: '/manganese/data-reports/forecasts',
  },
]

const PHOSPHATE_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/phosphate',
  },
  {
    name: 'Market Insights',
    href: '/phosphate/market-insights/analysis',
  },
  {
    name: 'Data & Reports',
    href: '/phosphate/data-reports/forecasts',
  },
]

const FLUORSPAR_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/fluorspar',
  },
  {
    name: 'Market Insights',
    href: '/fluorspar/market-insights/analysis',
  },
  {
    name: 'Data & Reports',
    href: '/fluorspar/data-reports/forecasts',
  },
]

const ANODE_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/anode',
  },
  {
    name: 'Market Insights',
    href: '/anode/market-insights/analysis',
  },
  {
    name: 'Anode Prices',
    href: '/anode/prices',
  },
  {
    name: 'Data & Reports',
    href: '/anode/data-reports/price-assessments',
  },
  {
    name: 'Capacity Database',
    href: '/anode/capacity-database',
  },
]

const CATHODE_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/cathode',
  },
  {
    name: 'Market Insights',
    href: '/cathode/market-insights/analysis',
  },
  {
    name: 'Cathode Prices',
    href: '/cathode/prices',
  },
  {
    name: 'Data & Reports',
    href: '/cathode/data-reports/price-assessments',
  },
  {
    name: 'Capacity Database',
    href: '/cathode/capacity-database',
  },
]

const BATTERY_GIGAFACTORY_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/battery-gigafactory/portal',
  },
  {
    name: 'Market Insights',
    href: '/battery-gigafactory/market-insights/analysis',
  },
  {
    name: 'Battery Prices',
    href: '/battery-gigafactory/lithium-ion-batteries-prices',
  },
  {
    name: 'Data & Reports',
    href: '/battery-gigafactory/data-reports/price-assessments',
  },
  {
    name: 'Capacity Database',
    href: '/battery-gigafactory/capacity-database',
  },
]

const NEW_TECH_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/new-technology/portal',
  },
  {
    name: 'Market Insights',
    href: '/new-technology/market-insights/analysis',
  },
  {
    name: 'Data & Reports',
    href: '/new-technology/data-reports/forecasts',
  },
]

const SILICON_ANODE_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/silicon-anode',
  },
  {
    name: 'Market Insights',
    href: '/silicon-anode/market-insights/analysis',
  },
  {
    name: 'Data & Reports',
    href: '/silicon-anode/data-reports/forecasts',
  },
]

const RECYCLING_TABS: TContextualTab[] = [
  {
    name: 'Portal',
    href: '/recycling/portal',
  },
  {
    name: 'Market Insights',
    href: '/recycling/market-insights/analysis',
  },
  {
    name: 'Black Mass Prices',
    href: '/recycling/black-mass-prices',
  },
  {
    name: 'Data & Reports',
    href: '/recycling/data-reports/price-assessments',
  },
]

const PRICE_DASHBOARD_TABS: TContextualTab[] = [
  {
    name: 'Chart builder',
    href: '/price-dashboard/chart-builder',
  },
  {
    name: 'Watchlist',
    href: '/price-dashboard/watchlist',
  },
]

const TOOLS_PRICE_DASHBOARD_TABS: TContextualTab[] = [
  {
    name: 'Chart builder',
    href: '/price-dashboard/chart-builder',
  },
  {
    name: 'Watchlist',
    href: '/price-dashboard/watchlist',
  },
]

export const NAVIGATION_ITEMS = (): TNavigationItem[] => [
  {
    name: 'Price Dashboard',
    href: '/price-dashboard/chart-builder',
    current: false,
    tabs: PRICE_DASHBOARD_TABS,
  },
  {
    name: 'Raw Materials',
    current: false,
    children: [
      { name: 'Lithium', href: '/lithium', tabs: LITHIUM_TABS, current: false },
      { name: 'Cobalt', href: '/cobalt', tabs: COBALT_TABS, current: false },
      {
        name: 'Copper',
        href: '/copper/portal',
        tabs: COPPER_TABS,
        current: false,
      },
      { name: 'Nickel', href: '/nickel', tabs: NICKEL_TABS, current: false },
      {
        name: 'Synthetic Graphite',
        tabs: SYNTHETIC_GRAPHITE_TABS,
        href: '/synthetic-graphite',
        current: false,
      },
      {
        name: 'Natural Graphite',
        tabs: NATURAL_GRAPHITE_TABS,
        href: '/natural-graphite',
        current: false,
      },
      {
        name: 'Rare Earths',
        href: '/rare-earths',
        tabs: RARE_EARTHS_TABS,
        current: false,
      },
      {
        name: 'Manganese',
        href: '/manganese',
        tabs: MANGANESE_TABS,
        current: false,
      },
      {
        name: 'Phosphate',
        href: '/phosphate',
        tabs: PHOSPHATE_TABS,
        current: false,
      },
      {
        name: 'Fluorspar',
        href: '/fluorspar',
        tabs: FLUORSPAR_TABS,
        current: false,
      },
    ],
  },
  {
    name: 'Active Materials',
    current: false,
    children: [
      { name: 'Anode', href: '/anode', tabs: ANODE_TABS, current: false },
      { name: 'Cathode', href: '/cathode', tabs: CATHODE_TABS, current: false },
      {
        name: 'Silicon Anode',
        href: '/silicon-anode',
        tabs: SILICON_ANODE_TABS,
        current: false,
      },
    ],
  },
  {
    name: 'Battery & Gigafactory',
    current: false,
    children: [
      {
        name: 'Battery',
        href: '/battery-gigafactory/portal',
        tabs: BATTERY_GIGAFACTORY_TABS,
        current: false,
      },
    ],
  },
  {
    name: 'New Technology',
    current: false,
    children: [
      {
        name: 'New Tech',
        href: '/new-technology/portal',
        tabs: NEW_TECH_TABS,
        current: false,
      },
    ],
  },
  {
    name: 'Battery Recycling',
    current: false,
    children: [
      {
        name: 'Battery Recycling',
        href: '/recycling',
        tabs: RECYCLING_TABS,
        current: false,
      },
    ],
  },
]

export const TOOLS_NAVIGATION_ITEMS = [
  {
    name: 'Home',
    href: '/tools',
    current: false,
  },
  {
    name: 'Price Dashboard',
    href: '/price-dashboard/chart-builder',
    current: false,
    tabs: TOOLS_PRICE_DASHBOARD_TABS,
  },
  {
    name: 'Battery Emission Analyser',
    href: '/battery-emissions-analyser',
    current: false,
    tabs: TOOLS_PRICE_DASHBOARD_TABS,
  },
  {
    name: 'Benchmark API',
    href: '/tools/api',
    current: false,
  },
  {
    name: 'Excel Add-In',
    href: `/excel-add-in`,
    current: false,
    tabs: TOOLS_PRICE_DASHBOARD_TABS,
  },
  {
    name: 'Benchmark App',
    href: `/app`,
    current: false,
    tabs: TOOLS_PRICE_DASHBOARD_TABS,
  },
]
